import { useState } from "react";
import { api } from "@/lib/api";
import { Button, Field } from "@/components/ui";

export function LoginPage({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [f, setF] = useState({ username: "", password: "" });
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try { await api.post("/auth/login", f); onLoggedIn(); } catch (x) { setErr((x as Error).message); } finally { setBusy(false); }
  };
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <form onSubmit={submit} className="card" style={{ width: "100%", maxWidth: 360, padding: 28, display: "flex", flexDirection: "column", gap: 14 }}>
        <img src="/assets/hixonops-wordmark.png" alt="HixonOps" style={{ height: 26, alignSelf: "flex-start" }} />
        <div className="col gap-2"><h1 style={{ fontSize: 15 }}>Sign in to OpsDesk</h1><span className="small muted">Username and password, until Cloudflare Access is switched on.</span></div>
        <Field label="Username"><input className="input" autoFocus autoComplete="username" value={f.username} onChange={(e) => setF((x) => ({ ...x, username: e.target.value }))} /></Field>
        <Field label="Password"><input className="input" type="password" autoComplete="current-password" value={f.password} onChange={(e) => setF((x) => ({ ...x, password: e.target.value }))} /></Field>
        {err && <div className="small" style={{ color: "var(--status-red-text)" }}>{err}</div>}
        <Button variant="primary" type="submit" disabled={busy || !f.username || !f.password}>Sign in</Button>
      </form>
    </div>
  );
}
